import { Path } from '@/main/router/routerPath';

import { ZakaznickaKategorie } from './zakaznickaKategorie';
import { ZakaznickaSkupina } from './zakaznickaSkupina';
import { ZakaznickyTitul } from './zakaznickyTitul';
import { ZarazeniZakaznik } from './zarazeniZakaznik';
import { Department } from './Department';
import { ChargeType } from './ChargeType';

export const router = new Path('Zakaznicke').addChildren([
	ZakaznickaKategorie.router,
	ZakaznickaSkupina.router,
	ZakaznickyTitul.router,
	ZarazeniZakaznik.router,
	Department.router,
	ChargeType.router,
]);
